import { Map } from 'immutable';
import Toast from './Toast';

export const DefaultCommonConfig = Map({
  Toast,
});
